const setOpenNewSpaceModalAction = ({ commit }, payload: boolean): void => {
  commit("setOpenNewSpaceModal", payload);
};

export default {
  setOpenNewSpaceModalAction,
};
